import { Component, EventEmitter, OnInit, Output,Inject, PLATFORM_ID } from '@angular/core';
import { AuthService, ConstantService, HelperService, ApiService,SeoService,  PaginationService } from '../../core/services';
import { ActivatedRoute, NavigationEnd, NavigationStart, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { Meta, Title, MetaDefinition } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from "ngx-spinner";
import { isPlatformBrowser, isPlatformServer } from
  '@angular/common';

@Component({
  selector: 'app-episode-detail',
  templateUrl: './episode-detail.component.html',
  styleUrls: ['./episode-detail.component.css']
})
export class EpisodeDetailComponent implements OnInit {

  userSubscription: Subscription;
  hostName = environment.BaseURL +"/podcasts-web/episode/";
  episodeDetail:any = {};
  objectKeys = Object.keys;
  podcastArticles:any = [];


  constructor(private authSvc: AuthService,
    private constantSvc: ConstantService,
    private apiSvc: ApiService,
    private helperSvc: HelperService,
    private title: Title,
    private seoService: SeoService,
    private pagerService: PaginationService,
    private router: Router, private spinner: NgxSpinnerService,
    private _route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platform: Object,
    @Inject(DOCUMENT) private _document: any)  {
    this.userSubscription = this._route.params.subscribe(
      (params: Params) => {
        const desc = this._route.snapshot.paramMap.get('episodename')!;
        let alias = desc;
        this.getEpisodeByAlias(alias);
        this.getPodcastArticles();
      })
   }

  ngOnInit(): void {
  }


  getEpisodeByAlias(alias) {
    this.spinner.show();
    this.apiSvc.getService(this.constantSvc.APIConfig.GETEPISODEDETAILBYALIAS, '?alias=' + alias).subscribe(
      res => {
        if (res) {
          let data = res;
          this.episodeDetail = data.data;
          let episode = this.episodeDetail
          let descWithoutTags = episode.description ? episode.description .replace(/<(.|\n)*?>/g, '') : '';
            this.seoService.updateCanonicalUrl(this.hostName + episode.alias);
            this.seoService.updateImageSorce(episode.image);
            this.title.setTitle(episode.title + ' | Hayti - News, Videos and Podcasts from Black Publishers');
            this.seoService.updateMetaTags([
              { name: 'keywords', content: '' },
              { name: 'description', content: descWithoutTags },
              { property: 'og:title', content: episode.title },
              { property: 'og:url', content: this.hostName + episode.alias },
              { property: 'og:description', content: descWithoutTags },
              { property: 'og:image', content: episode.image },
              { property: 'og:image:url', content: episode.image },
              { property: "og:site_name", content: "Hayti - News, Videos and Podcasts from Black Publishers" },
              { property: "og:type", content: "podcast" },

              { name: "twitter:card", content: "summary_large_image" },
              { name: 'twitter:site', content: '@haytiapp' },
              { name: 'twitter:description', content: descWithoutTags },
              { name: 'twitter:title', content: episode.title },
              { name: 'twitter:creator', content: '@haytiapp' },
              { name: 'twitter:url', content: this.hostName + episode.alias },
              { name: 'twitter:image', content: episode.image },
              { name: 'twitter:image:alt', content: episode.image }
            ]);

          // if (data.podcast_name == null) {
          //   this.router.navigate(['/404'], { skipLocationChange: true });
          // }
          this.spinner.hide();
        }
      }, err => {
        this.spinner.hide();
      }
    );
  }

  playAudio(episode) {
    this.helperSvc.changeAudioData(episode);  //invoke new Dat
    this.helperSvc.setAudioPlayerList(episode);
  }

  secondsToDhmsOld(seconds) {
    seconds = Number(seconds);
    var h = Math.floor(seconds % (3600 * 24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);

    var hDisplay = h > 0 ? (h < 10 ? "0" + h : h) : "00";
    var mDisplay = m > 0 ? (m < 10 ? "0" + m : m) : "00";
    var sDisplay = s > 0 ? (s < 10 ? "0" + s : s) : "00";
    return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }

  secondsToDhms(seconds) {
    const portions: string[] = [];
  
    const msInHour = 1000 * 60 * 60;
    const hours = Math.floor(seconds % (3600 * 24) / 3600);
    if (hours > 0) {
      portions.push(hours + ' h');
      // duration = duration - (hours * msInHour);
    }
  
    const msInMinute = 1000 * 60;
    const minutes =  Math.floor(seconds % 3600 / 60);
    if (minutes > 0) {
      portions.push(minutes + ' min');
      // duration = duration - (minutes * msInMinute);
    }
  
    const sec =  Math.floor(seconds % 60);
    if (sec > 0) {
      portions.push(sec + ' sec');
    }
  
    return portions.join(' ');
  }

  getPodcastArticles() {
    this.apiSvc.getService(this.constantSvc.APIConfig.GETPODCASTARTICLENEWS, '').subscribe(
      res => {
        if (res) {
          let data = res;
          this.podcastArticles = data.articlesLists;
          
        }
      }, err => {
      }
    );
  }
}
